import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SettingsService } from '../services/settings.service';
import { UserSettings } from "fakturnia-shared";
import { switchMap, of } from 'rxjs';

export const IsAuthenticatedAdminGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const settingsService = inject(SettingsService);

  return settingsService.getUserSettings().pipe(
    switchMap((userSettings: UserSettings) => {
      return authService.isLoggedIn$.pipe(
        switchMap((isLoggedin: boolean) => {
          const role = userSettings.user.role;
          if (!isLoggedin || role !== 'administrator') {
            router.navigate(['logowanie']);
            return of(false); // User is not authenticated or not an admin
          }
          return of(true); // User is authenticated and is an admin
        })
      );
    })
  );
};
